import { useMediaQuery, useTheme } from "@mui/material";
import logo from "../../Assests/in5.png";

export default function Loader() {
  const theme = useTheme();
  const ismobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <div className="loader">
      <div className="circles">
        <div className="circle1" />
        <div className="circle2" />
        <div className="circle3" />
        <img
          src={logo}
          style={{
            height: ismobileScreen ? "80px" : "120px",
            width: "auto",
            padding: ismobileScreen ? "15px" : "10px",
            position: "absolute",
            background: "#fff",
            top: "50%",
            borderRadius: "20px",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </div>
  );
}
